import React from 'react';

const MessageHeading = ({ text, className, border, padding, noMargin, customPadding }) => {
    return (
        <h5 className={`${className || ''}  ${!text?.length ? "headingLoader square" : ""} theme-text-color ${!border && 'theme-border-secondary-color'} ${customPadding ? customPadding : (!padding && 'pb-3')} ${noMargin ? 'mb-1' : 'mb-3'} mt-0 `}>
            {text}
        </h5>
    );
};

export default MessageHeading;